import { gql } from '@apollo/client';

const GET_FDA_CONTRACT_DELTA_REPORT = gql`
  query GetFdaContractDeltaReportQuery($deltaInstances: [Int!]!, $ohts: [Int!], $orgId: Int) {
    fdaContractDeltaReport(deltaInstances: $deltaInstances, ohts: $ohts, orgId: $orgId) {
      Acronym
      Name
      Trend
      Practice {
        Name
      }
      GroupLevel
      NumberWithinLevel
      DeltaSatisfied
      DeltaAggregate
      InstanceEvaluationDetails {
        Instance
        SatisfiedPercentage
        AggregatePercentage
        Count
      }
    }
  }
`;

export default GET_FDA_CONTRACT_DELTA_REPORT;
